document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.section-wear-the-mission');
  if (!root) return;

  // Scroll pop-in
  var targets = root.querySelectorAll('.fade-in-up');
  if (targets.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );
      targets.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  // Quick view modal
  var modal = document.getElementById('wear-the-mission-modal');
  if (!modal) return;

  var modalImage = modal.querySelector('[data-modal-image]');
  var modalTitle = modal.querySelector('[data-modal-title]');
  var modalPrice = modal.querySelector('[data-modal-price]');
  var modalDescription = modal.querySelector('[data-modal-description]');
  var modalOptions = modal.querySelector('[data-modal-options]');
  var modalAddBtn = modal.querySelector('[data-modal-add-to-cart]');
  var modalStatus = modal.querySelector('[data-modal-status]');
  var closeBtn = modal.querySelector('[data-quick-view-close]');
  var prevBtn = modal.querySelector('[data-modal-prev]');
  var nextBtn = modal.querySelector('[data-modal-next]');
  var quantityInput = modal.querySelector('[data-modal-quantity]');
  var quantityDecreaseBtn = modal.querySelector('[data-quantity-decrease]');
  var quantityIncreaseBtn = modal.querySelector('[data-quantity-increase]');

  var currentProduct = null;
  var selectedOptions = [];
  var currentImageIndex = 0;

  function showImage(index) {
    if (!currentProduct || !currentProduct.images.length) return;
    var total = currentProduct.images.length;
    currentImageIndex = ((index % total) + total) % total;
    modalImage.src = currentProduct.images[currentImageIndex];
  }

  function updateGalleryNav() {
    var hasMultiple = currentProduct && currentProduct.images.length > 1;
    if (prevBtn) prevBtn.hidden = !hasMultiple;
    if (nextBtn) nextBtn.hidden = !hasMultiple;
  }

  function findMatchingVariant() {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (variant) {
      return variant.options.every(function (val, idx) {
        return val === selectedOptions[idx];
      });
    });
  }

  function renderOptions() {
    modalOptions.innerHTML = '';
    if (!currentProduct.options || currentProduct.options.length < 1) return;
    var variants = currentProduct.variants || [];
    if (variants.length === 1 && variants[0].title === 'Default Title') return;

    currentProduct.options.forEach(function (option, index) {
      var wrapper = document.createElement('div');
      var label = document.createElement('label');
      label.textContent = option.name;
      var select = document.createElement('select');
      select.setAttribute('data-option-index', index);

      option.values.forEach(function (value) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      select.addEventListener('change', function () {
        selectedOptions[index] = select.value;
        updateForVariant();
      });

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      modalOptions.appendChild(wrapper);
    });
  }

  function updateForVariant() {
    var variant = findMatchingVariant();
    if (!variant) return;
    modalPrice.textContent = variant.price;
    modalAddBtn.disabled = !variant.available;
    modalAddBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    modalStatus.textContent = '';
    modalAddBtn.setAttribute('data-variant-id', variant.id);

    var variantImageIndex = currentProduct.images.indexOf(variant.image);
    showImage(variantImageIndex > -1 ? variantImageIndex : 0);
  }

  function openModalFor(handle) {
    var script = root.querySelector('script[data-product-json="' + handle + '"]');
    if (!script) return;

    try {
      currentProduct = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    selectedOptions = currentProduct.variants[0] ? currentProduct.variants[0].options.slice() : [];

    modalTitle.textContent = currentProduct.title;
    modalDescription.textContent = currentProduct.description;
    modalStatus.textContent = '';
    if (quantityInput) quantityInput.value = 1;
    updateGalleryNav();

    renderOptions();

    // Set selects to the first variant's option values
    var selects = modalOptions.querySelectorAll('select');
    selects.forEach(function (select, idx) {
      if (selectedOptions[idx]) select.value = selectedOptions[idx];
    });

    updateForVariant();

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  root.querySelectorAll('[data-quick-view-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openModalFor(trigger.getAttribute('data-product-handle'));
    });
  });

  closeBtn.addEventListener('click', function () {
    modal.close ? modal.close() : modal.removeAttribute('open');
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      showImage(currentImageIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      showImage(currentImageIndex + 1);
    });
  }

  if (quantityDecreaseBtn) {
    quantityDecreaseBtn.addEventListener('click', function () {
      var value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
      quantityInput.value = value;
    });
  }

  if (quantityIncreaseBtn) {
    quantityIncreaseBtn.addEventListener('click', function () {
      var value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) + 1);
      quantityInput.value = value;
    });
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      var value = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      quantityInput.value = value;
    });
  }

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.close ? modal.close() : modal.removeAttribute('open');
    }
  });

  modalAddBtn.addEventListener('click', function () {
    var variantId = modalAddBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

    modalAddBtn.disabled = true;
    modalStatus.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        modalStatus.innerHTML = 'Added to cart! <a href="/cart">View cart</a>';
        modalAddBtn.disabled = false;
      })
      .catch(function () {
        modalStatus.textContent = 'Something went wrong. Please try again.';
        modalAddBtn.disabled = false;
      });
  });
});